const config = {
  API_END_POINT: process.env.REACT_APP_API_END_POINT || "",
  LOCAL_STORAGE_TOKEN_KEY: process.env.REACT_APP_LOCAL_STORAGE_TOKEN_KEY || "",
  LIMIT_PER_PAGE: process.env.REACT_APP_LIMIT_PER_PAGE || "50",
  API_DATE_TIME_FORMATE: "YYYY-MM-DD HH:mm:ss",
};

export default config;
